import React, { Component } from "react";
import { css } from "glamor";
import * as styles from "../../cards/card.style";
import CardThumbnail from "../../../assets/images/Danske_bank_default.jpg";
import rightArrow from "../../../assets/icons/arrow-link-next_darkblue.svg";
import chevronRight from "../../../assets/icons/chevronRight.svg";
import { Link } from "react-router-dom";
import * as translate from "../../../assets/translations/translations";
import catalogTranslations from "../../../assets/translations/subcategories.json";

export default class CardCommr extends Component {
  constructor(props) {
    super(props);

    this.redirecttoArticle = this.redirecttoArticle.bind(this);
  }

  handleFile(filepath) {
    window.open(filepath, "_blank");
  }

  formatDate(date) {
    var date = new Date(date);
    return date.toLocaleDateString("da-DK").replace(/-/g, "/");
  }

  formatKeyword(keywords) {
    if (keywords == undefined || keywords == null) return;
    // Trim whitespace and remove leading/trailing commas
    const trimmedKeywords = keywords
      .trim()
      .replace(/^,+|,+$/g, "")
      .trim();
    if (trimmedKeywords === "") return;
    return (
      <Link
        aria-label={trimmedKeywords}
        alt={trimmedKeywords}
        to={`/keywords/${trimmedKeywords}`}
        onClick={(e) => e.stopPropagation()}
      >
        {" "}
        {trimmedKeywords ? (
          <span {...css(styles.focusTag)}>{trimmedKeywords}</span>
        ) : null}{" "}
      </Link>
    );
  }

  renderThumbnail(imagepath) {
    if (imagepath == undefined || imagepath == null) {
      return (
        <img
          className="card-image"
          src={CardThumbnail}
          alt="Default Thumbnail"
          {...css(styles.cardImage)}
        />
      );
    } else {
      return (
        <img
          className="card-image"
          src={imagepath}
          alt="Article Thumbnail"
          {...css(styles.cardImage)}
        />
      );
    }
  }

  getCatalogtranslations(text) {
    let edition = localStorage.getItem("language") || "EN";
    if (edition == "EN" || edition == "ALL") {
      return text;
    } else {
      if (catalogTranslations[text]) {
        let translationElement = catalogTranslations[text];
        let translatedText = translationElement[edition];
        return translatedText;
      } else {
        return text;
      }
    }
  }

  redirecttoArticle(event, articleid, language) {
    event.stopPropagation();
    this.props.history.push(`/article/${articleid}/${language}/commr`);
  }

  renderSubcategories(categoryInfo) {
    const ciCount = categoryInfo.length;
    return categoryInfo.map((ci, i) => (
      <span key={i}>
        {!!i && " "}
        <Link
          aria-label={this.getCatalogtranslations(ci.subcategory)}
          alt={this.getCatalogtranslations(ci.subcategory)}
          to={`/articlelist/${ci.subcategory.replace(/\s+/g, "-")}/commr`}
          {...css(styles.cardAnchor)}
          onClick={(e) => e.stopPropagation()}
        >
          {this.getCatalogtranslations(ci.subcategory)}
          {ciCount !== i + 1 && ","}
        </Link>
      </span>
    ));
  }

  render() {
    return (
      <div
        className="card"
        {...css(styles.card)}
        onClick={(e) =>
          this.redirecttoArticle(e, this.props.articleid, this.props.langauge)
        }
        role="region"
        aria-label="Card"
      >
        {this.renderThumbnail(this.props.thumbnail)}
        <div className="card-body" {...css(styles.cardBody)}>
          {this.formatKeyword(this.props.keywords)}
          {this.renderSubcategories(this.props.categoryInfo)}
          <p {...css(styles.cardDate)}>
            {this.formatDate(this.props.publisheddate)}
          </p>
          {/* <h4 {...css(styles.cardTitle)}>{this.props.title}</h4> */}
          <h2 {...css(styles.cardTitle)}>{this.props.title}</h2>
          <p
            dangerouslySetInnerHTML={{ __html: this.props.summary }}
            {...css(styles.cardText)}
            className="card-summaryText"
          ></p>
          <div {...css(styles.shareContainer)}>
            {/*<span>
                            <img src={ShareIcon} />
                        </span>*/}
            <Link
              {...css(styles.readMore)}
              aria-label={translate.strings.TR18}
              alt={translate.strings.TR18}
              to={{
                pathname: `/article/${this.props.articleid}/${this.props.langauge}/commr`,
              }}
            >
              {translate.strings.TR18}{" "}
              <img
                {...css(styles.rightArrow)}
                src={chevronRight}
                alt={translate.strings.TR18}
              />
              {/* <img {...css(styles.rightArrow)} src={rightArrow} alt={"Right Arrow"} /> */}
            </Link>
          </div>
        </div>
      </div>
    );
  }
}
